/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Refineexampleblackwhiteprompt4Inputs */

const en_refineexampleblackwhiteprompt4 = /** @type {(inputs: Refineexampleblackwhiteprompt4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turn it into an elegant black and white photo`)
};

const de_refineexampleblackwhiteprompt4 = /** @type {(inputs: Refineexampleblackwhiteprompt4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wandle das Bild in ein elegantes Schwarz-Weiß-Foto um`)
};

/**
* | output |
* | --- |
* | "Turn it into an elegant black and white photo" |
*
* @param {Refineexampleblackwhiteprompt4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const refineexampleblackwhiteprompt4 = /** @type {((inputs?: Refineexampleblackwhiteprompt4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Refineexampleblackwhiteprompt4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_refineexampleblackwhiteprompt4(inputs)
	return de_refineexampleblackwhiteprompt4(inputs)
});
export { refineexampleblackwhiteprompt4 as "refineExampleBlackWhitePrompt" }